
import {
    determineGetDataSource,
    determineGetSsrDataExportFn,
} from '@cfra-nextgen-frontend/shared/src/components/Screener/utils/ssr';
import { getScreenerDataSSR } from 'components/screener/api/screener';

export const getSsrDataExportFn = determineGetSsrDataExportFn(getScreenerDataSSR);
export const getDataSource = determineGetDataSource(getScreenerDataSSR);
